import { render } from "./NewPlan.vue?vue&type=template&id=31221589&scoped=true"
import script from "./NewPlan.vue?vue&type=script&lang=js"
export * from "./NewPlan.vue?vue&type=script&lang=js"

import "./NewPlan.vue?vue&type=style&index=0&id=31221589&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31221589"]])

export default __exports__